import { mapStateToControlProps, rankWith } from '@jsonforms/core';
import { html } from '@microsoft/fast-element';
import { isOneOfBoolean } from '../testers/isOneOfBoolean';
import { BOOLEAN_CONTROL_RANK } from './RenderersRanks';
export const BooleanControlRendererTemplate = (prefix = 'zero') => html `
  <template>
    <control-wrapper
      :control=${(x) => x.control}
      :touched=${(x) => x.touched}
      ?submitted=${(x) => x.submitted}
    >
      <${prefix}-checkbox
        :checked=${(x) => x.control.data}
        ?disabled=${(x) => !x.control.enabled}
        :autofocus=${(x) => x.control.config.focus}
        :placeholder=${(x) => x.control.config.placeholder}
        @change=${(x, c) => {
    x.control.handleChange(x.control.path, c.event.target.checked);
    x.onBlur();
}}
        id=${(x) => x.control.path}
        data-test-id=${(x) => x.control.path}
      ></${prefix}-checkbox>
    </control-wrapper>
  </template>
`;
export const BooleanControlEntry = {
    renderer: html `
    ${(x) => BooleanControlRendererTemplate(x.jsonforms.prefix)}
  `,
    tester: rankWith(BOOLEAN_CONTROL_RANK, isOneOfBoolean),
    mapper: mapStateToControlProps,
};
